export default __webpack_public_path__ + "static/media/Documentos-Afiliacion-banco-de-guayaquil.bb1b027e.pdf";